class QuickbuyVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onOptionChange = this.onOptionChange.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.url = this.dataset.url;
    this.formId = this.dataset.productFormId;
    this.form = document.getElementById(this.formId);

    this.addEventListener('change', this.onOptionChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onOptionChange);
  }

  async onOptionChange(event) {
    // Combined listings: We use old and new product urls to determine if the product should change
    const oldProductUrl = this.url;
    const newProductUrl = event.target.dataset.productUrl;

    // get selected option value IDs and format
    const selectedOptions = this.selectedOptionValues;
    
    const params = selectedOptions.length > 0
      ? `&option_values=${selectedOptions.join(',')}`
      : '';
    const baseUrl = newProductUrl ? newProductUrl : oldProductUrl
    const fetchUrl = `${baseUrl}${baseUrl.indexOf('?') > -1? `&` : `?`}section_id=card-product${params}`

    const response = await fetch(fetchUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) return;

    const htmlText = await response.text();
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');

    // update variant id in form
    const newForm = doc.querySelector('form[id^="card-product__product-form--"]');

    if (newForm) {
      const newVariantId = newForm.querySelector('input[name="id"]').value;
      
      const allFormsWithSameId = document.querySelectorAll(`form[id="${this.formId}"]`);
      allFormsWithSameId.forEach(form => {
        form.querySelector('input[name="id"]').value = newVariantId;
        this.updateItemPropertiesForForm(newForm, form);
      });
    }

    // update price
    const newPrice = doc.querySelector('.price__container');
    const oldPrice = this.closest('.product-card-wrapper').querySelectorAll('.price__container');

    if (newPrice && oldPrice) {
      oldPrice.forEach((price) => {
        price.innerHTML = newPrice.innerHTML;
      });
    }

    // update heading
    const newHeading = doc.querySelector('.card__heading');
    const oldHeading = this.closest('.product-card-wrapper').querySelector('.card__heading');

    if (newHeading && oldHeading) {
      oldHeading.innerHTML = newHeading.innerHTML;
    }

    // update add to cart button
    const addButtonUpdated = doc.querySelector(`[id^=ProductSubmitButton-`);
      
    if (addButtonUpdated) {
      const isDisabled = addButtonUpdated.hasAttribute('disabled');
      const buttonText = addButtonUpdated.querySelector('.product-form__add-button-text')?.textContent?.trim();
      
      this.toggleAddButton(
        isDisabled,
        isDisabled ? window.variantStrings.soldOut : buttonText
      );
    }

    // update media
    const newMedia = doc.querySelector('.card__media');
    const oldMedia = this.closest('.product-card-wrapper').querySelector('.card__media');

    if (newMedia && oldMedia) {
      oldMedia.innerHTML = newMedia.innerHTML;
    }
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  updateItemPropertiesForForm(newForm, targetForm) {
    targetForm.querySelectorAll('.product-preorder-property').forEach(input => input.remove());
    targetForm.querySelectorAll('.product-final-sale-property').forEach(input => input.remove());
    
    const newPreorderProperty = newForm.querySelector('.product-preorder-property');
    const newFinalSaleProperty = newForm.querySelector('.product-final-sale-property');
    
    if (newPreorderProperty) {
      const clonedPreorderProperty = newPreorderProperty.cloneNode(true);
      targetForm.appendChild(clonedPreorderProperty);
    }
    
    if (newFinalSaleProperty) {
      const clonedFinalSaleProperty = newFinalSaleProperty.cloneNode(true);
      targetForm.appendChild(clonedFinalSaleProperty);
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(this.formId);

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = text || window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
}

customElements.define('quickbuy-variant-selects', QuickbuyVariantSelects);
